import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconMoreHorizLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.23 13.5c-.412 0-.765-.147-1.059-.44a1.444 1.444 0 0 1-.44-1.06c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44.412 0 .765.147 1.06.44.293.294.44.648.44 1.06 0 .412-.147.766-.44 1.06a1.45 1.45 0 0 1-1.06.44Zm5.77 0a1.45 1.45 0 0 1-1.06-.44A1.444 1.444 0 0 1 10.5 12c0-.412.147-.766.44-1.06A1.45 1.45 0 0 1 12 10.5c.412 0 .765.147 1.06.44.293.294.44.648.44 1.06 0 .412-.147.766-.44 1.06a1.45 1.45 0 0 1-1.06.44Zm5.77 0c-.413 0-.767-.147-1.06-.44a1.444 1.444 0 0 1-.44-1.06c0-.412.146-.766.44-1.06.293-.293.647-.44 1.06-.44.412 0 .765.147 1.058.44.294.294.441.648.441 1.06 0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconMoreHorizLine;
